import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from '@angular/forms';
import { DropdownItem } from '../../models/commonModel';
import { ErrorStateMatcher } from '@angular/material/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control?.parent?.dirty);
    const invalidParent = !!(control && control.parent && control.parent.invalid && control.parent.dirty);

    return (invalidCtrl || invalidParent);
  }
}
@Component({
  selector: 'app-qualificationtab',
  templateUrl: './qualificationtab.component.html',
  styleUrls: ['./qualificationtab.component.scss']
})
export class QualificationtabComponent implements OnInit, OnChanges {
  @Input()
  QualificationTab!: FormGroup;
  @Input() 
  QualificationTypes!: DropdownItem[];
  @Input()
  IsReadonly: boolean = false;
  @Input()
  IsVefify: boolean = false;
  isEmailSaved = false;
  entityName: string = '';
  @Input()
  IsExternal = false;
  @Output() ecnTabOut: EventEmitter<any> = new EventEmitter();
  @Output() feinTabOut: EventEmitter<any> = new EventEmitter();
  
  matcher = new MyErrorStateMatcher();
  constructor(
    private formBuilder: FormBuilder
  ) {
  }
  
  ngOnInit(): void {
    if (this.IsReadonly) {
      this.QualificationTab.disable();
      this.QualificationTab.controls['requestStatusTypeId'].enable();
      this.QualificationTab.controls['externalStatusTypeId'].enable();
    }
    if (this.IsVefify) {
      this.QualificationTab.disable();
      this.QualificationTab.controls['id'].enable();
      this.QualificationTab.controls['contactPhone'].enable();
      this.QualificationTab.controls['contactPhoneExtension'].enable();
      this.QualificationTab.controls['contactEmail'].enable();
      this.QualificationTab.controls['confirmEmail'].enable();
    }
  }

  onEcnFocusOutEvent(event: any) {
    this.ecnTabOut.emit(event);
  }

  onFeinFocusOutEvent(event: any) {
    this.feinTabOut.emit(event);
  }

  fitlerECN(event: any) {   
     var k;  
     k = event.keyCode;  //         k = event.keyCode;  (Both can be used)
     console.log(k);
     if (this.QualificationTab && this.QualificationTab.controls['entityControlNumber'].value && this.QualificationTab.controls['entityControlNumber'].value.length > 9) return false; 
     return (k >= 48 && k <= 57); 
  }

  ngOnChanges(): void {
    if (this.IsVefify) {
      this.QualificationTab.disable();
      this.QualificationTab.controls['id'].enable();
      this.QualificationTab.controls['contactPhone'].enable();
      this.QualificationTab.controls['contactPhoneExtension'].enable();
      this.QualificationTab.controls['contactEmail'].enable();
      this.QualificationTab.controls['confirmEmail'].enable();
    }
  }
  numericOnly(e: { which: any; keyCode: any; }) {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

}
